import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { useCallback } from 'react'
import { API_RULE_VIOLATION } from '../../../../constants/endpoints'
import { fetchStatusResolver } from '../../../../mfcLogic/api/utilities'
import { closeDialog } from '../../../../state/modals/state.dialog'
import Button from '../../../Buttons/Button'
import { AppStateType, useAppStateSelector } from '../../../Hooks/useAppState'
import { useUserSelector } from '../../../Hooks/useUser'
import { getThemeSpacing } from '../../../styles/appTheme'
import { maxWindowWidth } from '../../../styles/breakpoints'

const StyledRoot = styled('div')({
    padding: `${getThemeSpacing(2)} ${getThemeSpacing(4)}`,
    width: '100%',
    height: '100%',
    fontSize: '13px',
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    '& h1': {
        textAlign: 'center',
    },
})

const buttonStyles = css({
    margin: getThemeSpacing(1),
    marginTop: getThemeSpacing(3),
    // padding: `${getThemeSpacing(0.75)} ${getThemeSpacing(2)}`,
    [maxWindowWidth(360)]: {
        fontSize: 11,
    },
})

interface IRuleViolation {
    message?: string
}

const RuleViolation = (props: IRuleViolation) => {
    const { message } = props
    const token = useAppStateSelector(AppStateType.SESSION, 'token')
    const id = useUserSelector('me', 'id')
    const onConfirm = useCallback(() => {
        fetch(API_RULE_VIOLATION, {
            method: 'POST',
            credentials: 'include',
        })
            .then(fetchStatusResolver)
            .then(() => {
                // reload page
                location.reload()
                closeDialog()
            })
            .catch((err) => {
                console.warn(err)
            })
    }, [token, id])

    return (
        <StyledRoot data-testid="Container__RuleViolation">
            <div>
                <h1>Notice</h1>
                <p>
                    You have received the following message from MyFreeCams.com:
                </p>
                <p>
                    <strong data-testid="RuleViolation__Message">
                        {message}
                    </strong>
                </p>
            </div>
            <Button
                onClick={onConfirm}
                data-testid="Button__EnterMFC__Continue"
                css={buttonStyles}
                size="medium"
            >
                Continue
            </Button>
        </StyledRoot>
    )
}

export default RuleViolation
